import React, { useState } from "react";
import { Chip } from "@mui/material";
import { useDispatch } from "react-redux";
import { sendLocalMessage } from "../../store/actions/chatbot";

const QUESTION_GROUPS = [
  {
    label: "Getting Started",
    questions: [
      "How do I add a new appointment?",
      "How do I add a new client?",
      "How do I generate an invoice?",
    ],
  },
  {
    label: "Appointments",
    questions: [
      "How do I cancel an appointment?",
      "How do I assign staff to an appointment?",
      "What is a walk-in appointment?",
      "How do I reschedule an appointment?",
    ],
  },
  {
    label: "Staff",
    questions: [
      "How do I add a new staff member?",
      "How do I set staff working hours?",
      "How do I track staff commission?",
    ],
  },
  {
    label: "Clients",
    questions: [
      "How do I view a client's history?",
      "How do I add loyalty points to a client?",
      "How do I top up a client's wallet?",
    ],
  },
  {
    label: "Inventory",
    questions: [
      "How do I add a new product?",
      "How do I adjust stock levels?",
      "How do I add a new service?",
    ],
  },
  {
    label: "Billing",
    questions: [
      "How do I apply a discount to an invoice?",
      "How do I download an invoice?",
      "How do I search for an invoice?",
    ],
  },
  {
    label: "Support",
    questions: [
      "I want to raise a support ticket",
      "Check my ticket status",
    ],
  },
];

function QuickQuestions() {
  const dispatch = useDispatch();
  const [expanded, setExpanded] = useState(false);

  const handleClick = (question) => {
    dispatch(sendLocalMessage(question));
  };

  const visibleGroups = expanded ? QUESTION_GROUPS : QUESTION_GROUPS.slice(0, 2);

  return (
    <div className="quick-questions">
      {visibleGroups.map((group) => (
        <div key={group.label}>
          <div className="quick-questions__group-label">{group.label}</div>
          <div className="quick-questions__chips">
            {group.questions.map((q) => (
              <Chip
                key={q}
                label={q}
                size="small"
                variant="outlined"
                onClick={() => handleClick(q)}
                sx={{ cursor: "pointer", fontSize: "12px" }}
              />
            ))}
          </div>
        </div>
      ))}
      {!expanded && (
        <Chip
          label="Show more questions ▼"
          size="small"
          onClick={() => setExpanded(true)}
          sx={{ cursor: "pointer", fontSize: "12px", alignSelf: "flex-start", mt: 0.5 }}
        />
      )}
    </div>
  );
}

export default QuickQuestions;
